import React, { useState, useEffect } from "react";
import axios from "axios";

function TelevisionForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");

  useEffect(() => {
    if (subCategoryId) {
      axios.get(`https://api.herracim.az/api/Brand/BySubCategoryId?subCategoryId=${subCategoryId}`)
        .then(res => {
          setFilteredBrands(res.data);
          setFilteredModels([]);
        })
        .catch(err => console.error("Marka yükləmə xətası:", err));
    }
  }, [subCategoryId]);

  useEffect(() => {
    if (selectedBrand) {
      axios.get(`https://api.herracim.az/api/Model/ByBrandId?brandId=${selectedBrand}`)
        .then(res => setFilteredModels(res.data))
        .catch(err => console.error("Model yükləmə xətası:", err));
    }
  }, [selectedBrand]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setAdditionalAttributes(prev => ({
      ...prev,
      [name]: type === "number" ? parseFloat(value) : value
    }));
  };

  const handleBooleanChange = (e) => {
    setAdditionalAttributes(prev => ({
      ...prev,
      [e.target.name]: e.target.value === "true"
    }));
  };

  const handleBrandChange = (e) => {
    setSelectedBrand(e.target.value);
    setAdditionalAttributes(prev => ({
      ...prev,
      brandId: e.target.value,
      modelId: ""
    }));
  };

  return (
    <div className="televisionForm">
      <div>
        <h3>Marka *</h3>
        <select name="brandId" onChange={handleBrandChange}>
          <option value="">Seçin</option>
          {filteredBrands.map(brand => (
            <option key={brand.id} value={brand.id}>{brand.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>Model *</h3>
        <select name="modelId" onChange={handleChange}>
          <option value="">Seçin</option>
          {filteredModels.map(model => (
            <option key={model.id} value={model.id}>{model.name}</option>
          ))}
        </select>
      </div>

      <div><h3>Ekran ölçüsü (inch) *</h3><input type="number" name="screenSize" step="0.1" onChange={handleChange} /></div>

      <div>
        <h3>Qətnamə *</h3>
        <select name="resolution" onChange={handleChange}>
          <option value="">Seçin</option>
          <option value="HD">HD</option>
          <option value="Full HD">Full HD</option>
          <option value="4K">4K</option>
          <option value="8K">8K</option>
        </select>
      </div>

      <div>
        <h3>Smart TV? *</h3>
        <select name="isSmartTv" onChange={handleBooleanChange}>
          <option value="">Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>

      <div>
        <h3>Ekran tipi *</h3>
        <select name="screenType" onChange={handleChange}>
          <option value="">Seçin</option>
          <option value="LED">LED</option>
          <option value="OLED">OLED</option>
          <option value="QLED">QLED</option>
          <option value="LCD">LCD</option>
        </select>
      </div>

      <div><h3>HDMI port sayı *</h3><input type="number" name="hdmiPorts" onChange={handleChange} /></div>

      <div>
        <h3>Bluetooth *</h3>
        <select name="hasBluetooth" onChange={handleBooleanChange}>
          <option value="">Seçin</option>
          <option value="true">Var</option>
          <option value="false">Yoxdur</option>
        </select>
      </div>

      <div>
        <h3>Wi-Fi *</h3>
        <select name="hasWifi" onChange={handleBooleanChange}>
          <option value="">Seçin</option>
          <option value="true">Var</option>
          <option value="false">Yoxdur</option>
        </select>
      </div>

      <div><h3>Yenilənmə tezliyi (Hz) *</h3><input type="number" name="refreshRate" onChange={handleChange} /></div>

      <div><h3>USB port sayı *</h3><input type="number" name="usbPorts" onChange={handleChange} /></div>

      <div>
        <h3>Səs ilə idarəetmə *</h3>
        <select name="hasVoiceControl" onChange={handleBooleanChange}>
          <option value="">Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>

      <div>
        <h3>4K dəstəyi *</h3>
        <select name="supports4K" onChange={handleBooleanChange}>
          <option value="">Seçin</option>
          <option value="true">Var</option>
          <option value="false">Yoxdur</option>
        </select>
      </div>


      <div>
        <h3>Divara montaj dəstəyi *</h3>
        <select name="hasWallMountSupport" onChange={handleBooleanChange}>
          <option value="">Seçin</option>
          <option value="true">Var</option>
          <option value="false">Yoxdur</option>
        </select>
      </div>
    </div>
  );
}

export default TelevisionForm;
